var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectMultiple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5V16.1667C2.5 16.6334 2.5 16.8666 2.59083 17.0448C2.67072 17.2016 2.79811 17.3294 2.95492 17.4093C3.133 17.5 3.36625 17.5 3.83205 17.5H12.5001M14.1667 6.66667L10.8333 10L9.16667 8.33333M5.83333 11.5002V5.16683C5.83333 4.23341 5.83333 3.76635 6.01499 3.40983C6.17478 3.09623 6.42956 2.84144 6.74316 2.68166C7.09968 2.5 7.56674 2.5 8.50016 2.5H14.8335C15.7669 2.5 16.2334 2.5 16.5899 2.68166C16.9035 2.84144 17.1587 3.09623 17.3185 3.40983C17.5002 3.76635 17.5002 4.23308 17.5002 5.16648L17.5002 11.4998C17.5002 12.4333 17.5002 12.9 17.3185 13.2565C17.1587 13.5701 16.9035 13.8254 16.5899 13.9852C16.2337 14.1667 15.7679 14.1667 14.8363 14.1667H8.49742C7.56583 14.1667 7.09933 14.1667 6.74316 13.9852C6.42956 13.8254 6.17478 13.5702 6.01499 13.2566C5.83333 12.9001 5.83333 12.4336 5.83333 11.5002Z",
    stroke: "#0C9D61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectMultiple);
export default __webpack_public_path__ + "static/media/selectMultiple.5bf34521383e8335b8e3508ee7897c45.svg";
export { ForwardRef as ReactComponent };